<template>
    <Sidebar />
    <Content class="analytics-overview-content analytics-big-box" v-if="$store.state.user_data.merchant_account_id">
        <div class="inner inner-box">
            <AnalyticsHeader :show_check_box="true" :data_statistic="data_statistic" @handleSortLink="sortLinkClick"/>
            
            <div class="main">
                <Scrollbar class="left" id="body">
                    <!-- :products_num="[1,2]" is fake data for StorefrontSummary, products_num is for one creator -->
                    <StorefrontSummary ref="summary" v-if="can_start" :is_hide_date="true" :chart_id="'overview'" @update-data="getDoughnut();" 
                        :api_url="summary_api_url" :products_num="[1, 2]" :is_show_posts="true" :is_show_crt="true" 
                        :date_range="{ start_date: start_date, end_date: end_date }"
                        @handleSortLink="sortLinkClick" :show_last_datetime="true"
                        />
                    
                    <!-- id="scroll-left" 9389 #18改成最多SHOW 8個 -->
                    <ProductList  :is_loading="is_loading_products"
                        :is_loading_page="is_loading_products_page"
                        :date_range="{ start_date: start_date, end_date: end_date }" :title="'Top Products'"
                        :data="products" :sort_index="product_list_sort_index" @update-sort="getProductList"
                        :key="'product-list-' + product_list_filter" :data_statistic="data_statistic"
                        :show_data_statistic="false" :init_sortlink="sortlink_data" :is_swiper="true"/>

                    <div class="load-more-box">
                        <Button v-if="current_page < last_page" size="32" :color="'black-90'" :style="'border-square'" @click.native="$router.replace('/analytics/product')">See All</Button>
                    </div>
                    <div class="top-20" v-if="!top_post.loading">
                        <TopBrandPost :title="'Top Performing Branded Content'" :posts="top_post.data"
                            :posts_value="top_post" @clickPost="clickPost" @updateSort="updateSort" :had_navi="false"
                            @updateTag="updateTag" :selected_tags="selected_tags" :tag_text="default_text" :now_tab="1"
                            :creator_show="true" :is_swiper="true" />
                    </div>
                    <div class="load-more-box">
                        <Button v-if="top_post.data_total > 0" size="32" :color="'black-90'" :style="'border-square'" @click.native="$router.replace('/analytics/content')">See All</Button>
                    </div>
                    <Loading class="static" v-if="top_post.loading" />
                </Scrollbar>

                <Scrollbar class="right">
                    <TopCreator v-if="can_start" :start_date="start_date" :end_date="end_date" :init_sortlink="sortlink_data" ref="top_creator" @top_data="childApiDone.top_creator=true"/>
                    <div class="doughnut-box">
                        <div class="title">
                            <span>Traffic Source</span>
                            <Dropdown :items="doughnut_select" :direction_type="'right'" :icon_direction_type="'right'"
                                @update-dropdown="getDoughnutSource" ref="dropdown_source" />
                        </div>
                        <Loading class="static" v-if="is_loading_source" />
                        <Doughnut v-else :color="source_doughnut_color" ref="source" :key="is_loading_source" />
                    </div>
                    <div class="doughnut-box">
                        <div class="title">
                            <span>Operating Systems</span>
                            <Dropdown :items="doughnut_select" :direction_type="'right'" :icon_direction_type="'right'"
                                @update-dropdown="getDoughnutDevice" ref="dropdown_device" />
                        </div>
                        <Loading class="static" v-if="is_loading_device" />
                        <Doughnut v-else :color="device_doughnut_color" ref="device" :key="is_loading_device" />
                    </div>
                </Scrollbar>
            </div>
        </div>
    </Content>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import AnalyticsHeader from '@/components/analytics/AnalyticsHeader.vue';
import Button from '@/components/ui/Button.vue';
import Content from '@/components/ui/Content.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import ProductList from '@/components/product/ProductList.vue';
import StorefrontSummary from '@/components/summary/StorefrontSummary.vue';
import TopCreator from '@/components/summary/TopCreator.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Doughnut from '@/components/summary/Doughnut.vue';
import Field from '@/components/ui/Field.vue';
import Loading from '@/components/ui/Loading.vue';
import moment from 'moment';
import TopBrandPost from '@/components/TopBrandPost.vue';
import { SwitchTopSort, get_all_post_data } from '@/utils/ContentSwitchFun.js';
import { handleMaxMinFun } from '@/utils/SwitchFun.js';

export default {
    name: 'Analytics - Overview',

    data() {
        return {
            data: false,
            source_doughnut_color: ['#C32AA3', '#27364B', '#FAA378', '#1DB954', '#FF0000'],
            device_doughnut_color: ['#1DA1F2', '#4F4F4F', '#1DB954'],
            products: [],
            doughnut_select: [
                { id: 1, text: 'Views' },
                { id: 2, text: 'Clicks' },
                { id: 3, text: 'Sales' },
                { id: 4, text: 'Sales Value' },
            ],
            is_loading: true,
            is_loading_products_page: false,
            is_loading_products: true,
            is_loading_source: true,
            is_loading_device: true,
            start_date: moment().add(-30, 'days').toDate(),
            end_date: moment().add(-1, 'days').toDate(),
            product_list_filter: '',
            product_list_sort_index: 0,
            current_page: 1,
            last_page: 1,
            sourceList: [
                'instagram',
                'tiktok',
                'youtube',
                'motom',
                'search',
                'other',
                'linktree',
                'beacons',
            ],
            deivceList: [
                'android',
                'ios',
                'windows',
                'others',
            ],
            summary_api_url: '/analytics/merchant-account-statistic',
            product_sort: {
                key: 'views',
                val: 'desc'
            },
            top_post: get_all_post_data,
            default_text: 'Tags: All',
            tags: [],
            selected_tags: [],
            can_start:false,//阻止有些元件在時間整理完之前出現
            sortlink_data:0,
            data_statistic:null,//為了拿部分值給productList看
            childApiDone:{
                doughnut_source: false,
                doughnut_device: false,
                top_creator: false,
            }
        }
    },

    components: {
        Sidebar,
        Scrollbar,
        AnalyticsHeader,
        Button,
        Content,
        SvgIcon,
        ProductList,
        StorefrontSummary,
        TopCreator,
        Dropdown,
        Doughnut,
        Field,
        Loading,
        TopBrandPost,
    },

    watch: {
        '$store.state.user_data.merchant_account_id': function (val) {
            this.startFunction();
        },
        childApiDone: {
            handler(val) {
                if (val.doughnut_source && val.doughnut_device && val.top_creator) {
                    this.getTop();
                }
            },
            deep: true,
        },
    },

    methods: {

        sortLinkClick(val){
            this.sortlink_data=val;
            this.getProductList();
            this.$refs.summary.chart_type='view';
            this.$refs.summary.sortlink_data=this.sortlink_data;
            this.$refs.summary.getData();
            this.$refs.top_creator.sortlink_data=this.sortlink_data;
            this.$refs.top_creator.fetchData();
        },

        startFunction(){
            if(this.$store.state.user_data.merchant_account_id){
                this.sortlink_data= this.$store.state.save_sortlink_data;
                this.can_start=true;
                let checkTime = handleMaxMinFun( this.start_date, this.end_date ,this);
                this.start_date = checkTime[0];
                this.end_date= checkTime[1];
                this.getProductList();
                //this.getTop();
            }
        },

        getTopCreator() {
            if(this.$store.state.user_data.merchant_account_id){
                this.$refs.top_creator.type = 1;
                this.$refs.top_creator.fetchData();
            }
        },

        getDoughnut(data) {
            // this.is_loading_device = false;
            // this.is_loading_source = false;
            setTimeout(() => {
                if(data){
                    this.data_statistic=data.data;
                }
                this.$refs.dropdown_source.selected_index = 0;
                this.$refs.dropdown_device.selected_index = 0;
                this.getDoughnutSource();
                this.getDoughnutDevice();
            }, 10);
        },

        getDoughnutSource(obj) {
            if(this.$store.state.user_data.merchant_account_id){
                this.is_loading_source = true;
                let sort_key = 'page_views';
                if (obj) {
                    switch (obj.id) {
                        case 1:
                            sort_key = 'page_views';
                            break;

                        case 2:
                            sort_key = 'click';
                            break;

                        case 3:
                            sort_key = 'sales';
                            break;

                        case 4:
                            sort_key = 'sales_value';
                            break;

                        default:
                            break;
                    }

                    // console.log(sort_key)
                }
                let s = moment(this.start_date).format('YYYY-MM-DD');
                let e = moment(this.end_date).format('YYYY-MM-DD');
                let api = `/analytics/break-down/source?start_date=${s}&end_date=${e}&sort_key=${sort_key}`;

                this.$ajax(api, {
                    method: 'get',
                    withCredentials: true,
                }).then(res => {
                    this.is_loading_source = false;
                    this.childApiDone.doughnut_source = true;

                    //handle if name is abbr
                    let handleData = res.data.data.map(e => {
                        let index = -1
                        if (e.name.length == 1) {
                            index = this.sourceList.findIndex(ee => { return ee[0] == e.name })
                        }
                        return {
                            ...e,
                            name: index !== -1 ? this.sourceList[index] : e.name
                        }
                    })

                    this.$nextTick(() => {
                        if (this.$refs.source) this.$refs.source.update({
                            data: handleData,
                            type: sort_key,
                        });
                    });
                });
            }
        },

        getDoughnutDevice(obj) {
            if(this.$store.state.user_data.merchant_account_id){
                this.is_loading_device = true;
                this.childApiDone.doughnut_device = true;
                let sort_key = 'page_views';
                if (obj) {
                    switch (obj.id) {
                        case 1:
                            sort_key = 'page_views';
                            break;

                        case 2:
                            sort_key = 'click';
                            break;

                        case 3:
                            sort_key = 'sales';
                            break;

                        case 4:
                            sort_key = 'sales_value';
                            break;

                        default:
                            break;
                    }
                }
                let s = moment(this.start_date).format('YYYY-MM-DD');
                let e = moment(this.end_date).format('YYYY-MM-DD');
                let api = `/analytics/break-down/device-use?start_date=${s}&end_date=${e}&sort_key=${sort_key}`;

                this.$ajax(api, {
                    method: 'get',
                    withCredentials: true,
                }).then(res => {
                    this.is_loading_device = false;

                    //handle if name is abbr
                    let handleData = res.data.data.map(e => {
                        let index = -1
                        if (e.name.length == 1) {
                            index = this.deivceList.findIndex(ee => { return ee[0] == e.name });
                        }

                        // if (sort_key === 'sales_value') {
                        //     e.value = '' + Number(e.value).toFixed(2);
                        // }

                        return {
                            ...e,
                            name: index !== -1 ? this.deivceList[index] : e.name
                        }
                    })

                    this.$nextTick(() => {
                        if (this.$refs.device) this.$refs.device.update({
                            data: handleData,
                            type: sort_key,
                        });
                    })
                });
            }
        },

        getProductList(obj) {
            if(this.$store.state.user_data.merchant_account_id){
                this.is_loading_products = true;
                if (document.getElementById('body'))
                    document.getElementById('body').scrollTop = document.getElementById('body').scrollTop - 50;
                let s = moment(this.start_date).format('YYYY-MM-DD');
                let e = moment(this.end_date).format('YYYY-MM-DD');
                let api = `/creator/product-list?page=${this.current_page}&start_date=${s}&end_date=${e}&sort_key=${this.product_sort.key}&sort_val=${this.product_sort.val}&is_include_shortlink_data=${this.sortlink_data}`;

                if (obj) {
                    this.product_list_sort_index = obj.type.id - 1;

                    switch (obj.type.id) {
                        case 1:
                            this.product_sort.key = 'views';
                            this.product_sort.val = 'desc';
                            break;
                        case 2:
                            this.product_sort.key = 'views';
                            this.product_sort.val = 'asc';
                            break;

                        case 3:
                            this.product_sort.key = 'click';
                            this.product_sort.val = 'desc';
                            break;

                        case 4:
                            this.product_sort.key = 'click';
                            this.product_sort.val = 'asc';
                            break;

                        case 5:
                            this.product_sort.key = 'sales';
                            this.product_sort.val = 'desc';
                            break;
                        case 6:
                            this.product_sort.key = 'sales';
                            this.product_sort.val = 'asc';
                            break;

                        case 7:
                            this.product_sort.key = 'sales_value';
                            this.product_sort.val = 'desc';
                            break;

                        case 8:
                            this.product_sort.key = 'sales_value';
                            this.product_sort.val = 'asc';
                            break;

                        default:
                            break;
                    }

                    this.current_page = 1;
                    let newApi = `/creator/product-list?page=${this.current_page}&start_date=${obj.date.start}&end_date=${obj.date.end}&is_include_shortlink_data=${this.sortlink_data}`;
                    api = `${newApi}&sort_key=${this.product_sort.key}&sort_val=${this.product_sort.val}`;
                }

                if (this.current_page > 1) this.is_loading_products_page = true;

                this.$ajax(api, {
                    method: 'get',
                    withCredentials: true,
                }).then(res => {
                    if (this.current_page === 1)
                        //9389 #18改成最多SHOW 8個 
                        this.products = res.data.data.filter((e,k)=>{ return k < 8});
                    else
                        res.data.data.forEach(p => {
                            this.products.push(p);
                        });
                    this.product_list_filter = api.substring(api.indexOf('?') + 1);
                    this.current_page = Number(res.data.current_page);
                    this.last_page = Number(res.data.last_page);

                    setTimeout(() => {
                        this.is_loading_products = false;
                        this.is_loading = false;
                        this.is_loading_products_page = false;
                    }, 1000);
                });
            }
        },

        handleScroll() {
            let body = document.getElementById('body').scrollTop + 420;
            let scroll = document.getElementById('scroll-left').offsetHeight;
            // console.log(body)
            // console.log(scroll)

            if (body > scroll && !this.is_loading_products && this.current_page < this.last_page) {
                // console.log('more')
                this.current_page++;
                this.getProductList();
            }
        },

        updateSort(id) {
            // console.log('id', id)
            let getVal = SwitchTopSort(id.id);
            this.top_post.sort.sort_key = getVal.key;
            this.top_post.sort.sort_val = getVal.val;
            this.top_post.sort_index = this.top_post.sort_select.findIndex(obj => obj.id === id.id);
            this.top_post.drop_key += 1;
            this.getTop()
        },

        getTop() {
            if (this.$store.state.user_data.merchant_account_id) {
                this.top_post.loading = true;

                const baseParams = {
                    merchant_account_id: this.$store.state.user_data.merchant_account_id,
                    start_date: moment(this.start_date).format('YYYY-MM-DD'),
                    end_date: moment(this.end_date).format('YYYY-MM-DD'),
                    sort_key: this.top_post.sort.sort_key,
                    sort_val: this.top_post.sort.sort_val,
                    page: this.top_post.sort.page,
                    per_page: this.top_post.sort.per_page,
                    with_extra_count: '',
                    brand_post_only: 1
                };

                if (this.selected_tags.length > 0) {
                    baseParams.tag_ids = this.selected_tags.map(e => e.id);
                }

                const requests = [
                    { ...baseParams, social_platform: 'tikTok', social_post_type: 'video' },
                    { ...baseParams, social_platform: 'instagram', social_post_type: 'post' },
                    { ...baseParams, social_platform: 'instagram', social_post_type: 'reel' },
                    { ...baseParams, social_platform: 'instagram', social_post_type: 'story' }
                ];

                const tikTokPosts = [];
                const instagramOthers = [];
                const reels = [];
                const stories = [];

                Promise.all(requests.map(params =>
                    this.$ajax(`creator/get-social-account-posts`, { params, method: 'get' })
                )).then(responses => {
                    responses.forEach((res, index) => {
                        const originalData = res.data.data.social_posts.data.slice(0, 8); // 只取前8個

                        switch (index) {
                            case 0:
                                tikTokPosts.push(...originalData);
                                break;
                            case 1:
                                instagramOthers.push(...originalData);
                                break;
                            case 2:
                                reels.push(...originalData);
                                break;
                            case 3:
                                stories.push(...originalData);
                                break;
                        }
                    });

                    const total = instagramOthers.length + reels.length + stories.length;
                    this.top_post.data = [
                        { svg: 'tiktok-pure', which: 'TikTok', title: '', total: tikTokPosts.length, data: tikTokPosts, title_show: true },
                        { svg: 'instagram', which: 'Instagram', title: 'In-Feed', total, data: instagramOthers, title_show: true },
                        { svg: 'instagram', which: 'Instagram', title: 'Reels', total, data: reels, title_show: instagramOthers.length === 0 },
                        { svg: 'instagram', which: 'Instagram', title: 'Stories', total, data: stories, title_show: instagramOthers.length === 0 && reels.length === 0 }
                    ];

                    this.top_post.data_total = tikTokPosts.length + instagramOthers.length + reels.length + stories.length; // 四個陣列的長度加總
                    this.top_post.loading = false;
                }).catch(err => {
                    this.top_post.loading = false;
                });
            }
        },

        updateTag(tag) {
            if (tag === false) {
                this.selected_tags = [];
            } else if (this.selected_tags.findIndex(o => o.id === tag.id) === -1) {
                this.selected_tags.push(tag);
            } else {
                this.selected_tags = this.selected_tags.filter(o => o.id !== tag.id);
            }

            if (this.selected_tags.length === 0) {
                this.default_text = 'Tags: All';
            } else {
                this.default_text = 'Tags: ';
                this.selected_tags.forEach((v, k) => {
                    this.default_text += v.text + (k === this.selected_tags.length - 1 ? '' : ', ');
                });
            }

            this.getTop()
        },

        clickPost(val) {

        },
    },

    mounted() {
        if(!this.$store.state.user_data.permission_list.analytics.viewPerformanceSummaries.permission){
            this.$router.push('/creator/list');
            return;
        }
        this.startFunction();
        this.$store.state.creator_data = null;
        this.EventBus.off('update-date');
        this.EventBus.on('update-date', (obj) => {
            console.log('!update-date!')
            this.start_date = moment(obj.start_date).format('YYYY-MM-DD');
            this.end_date = moment(obj.end_date).format('YYYY-MM-DD');
            this.products = [];
            this.current_page = 1;
            this.last_page = 1;

            setTimeout(() => {
                this.getTopCreator();
                this.getProductList();
                this.getDoughnut();
                this.getTop();
            }, 100);
        });

        this.EventBus.on('updated-all-post-tag', (tags) => {
            if (this.selected_tags) this.selected_tags.forEach((tag, tag_index) => {
                const index = tags.findIndex((o) => o.id === tag.id);
                if (index === -1) {
                    // remove this tag
                    this.updateTag(tag);
                }
                this.getTop();
            });

            this.tags = tags;
        });

        //document.getElementById('body').addEventListener('scroll', this.handleScroll);
    },

    // beforeRouteLeave(to, from, next) {
    //     console.log('beforeRouteLeave',to, from)
    //     this.top_post.data = [];
    //     next();
    // },

    // destroyed() {
    //     console.log('destroyed')
    //     //document.getElementById('body').removeEventListener('scroll', this.handleScroll);
    // },
}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.analytics-overview-content {
    .inner {
        height: 100%;
        // display: flex;
        padding: 24px 48px; //24px 48px 0 48px;

        .main {
            height: calc(100% - 64px);
            display: flex;
            //padding-top: 36px;

            .left {
                width: 70%;
                min-width: 600px;

                .product-list {
                    margin-top: 36px;

                    .product-modal {
                        z-index: 2;
                    }
                }

                .load-more-box {
                    width: 100%;
                    @include flexCenter();
                    justify-content: center;
                    margin-top: 12px;

                    .ui-button {
                        width: 100%;
                        text-align: center;
                        @include flexCenter();
                        justify-content: center;
                    }
                }

                .top-20 {
                    margin-top: 24px;

                    .top-brand-post-box .title {
                        padding: 16px 0px;
                    }

                    .top-brand-post-box .tab-box {
                        margin-top: -44px;
                        padding: 0;
                        margin-bottom: 16px;
                    }
                }
            }

            .right {
                width: 30%;
                min-width: 340px;
                padding-left: 16px;

                .top-creator {
                    margin-bottom: 16px;

                    .creator-modal {
                        z-index: 2;
                    }
                }

                .doughnut-box {
                    margin-top: 16px;
                    padding: 12px;
                    border: 1px solid var(--border);
                    border-radius: 10px;

                    .title {
                        display: flex;
                        align-items: center;
                        font: var(--font-demi-20);
                        color: var(--black-90);

                        span {
                            flex: 1;
                        }

                        .dropdown {
                            width: fit-content;
                        }
                    }
                }
            }
        }


    }

    .storefront-summary .chart-box {
        overflow: hidden;
    }

}
</style>